export const isDevelopment = () => {
  // Check if we're in localhost
  const isLocalhost = window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';

  // Check if Node environment is development
  const isDevEnv = process.env.NODE_ENV === 'development';

  return isLocalhost || isDevEnv;
}; 